"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Components = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Input = _interopRequireDefault(require("../Input"));
var _templateObject, _templateObject2;
const Wrapper = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])([""])));
const InputElement = (0, _styledComponents["default"])(_Input["default"])(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])([""])));
const Components = exports.Components = {
  Wrapper,
  InputElement
};